import buildFormData from "../buildFormData";

const { useState, useEffect } = React;

const useWPAjaxMutation = (ajaxUrl, params) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const saveData = async (saveData) => {
    setIsError(false);
    setError(null);
    setIsLoading(true);

    const formData = new FormData();
    buildFormData(formData, { ...params, ...saveData });

    try {
      const request = await fetch(`${ajaxUrl}`, {
        method: "POST",
        body: formData,
      });
      const response = await request.json();
      setData(response.data);
      setIsLoading(false);
      return response.data;
    } catch (error) {
      setIsError(true);
      setError(error.message);
      setIsLoading(false);
    }
  };

  return { data, saveData, isLoading, isError, error };
};

export default useWPAjaxMutation;
